import React, { useContext, useEffect } from 'react'
import { FetchProductStock } from './productCatalogAPI';
import InventoryUI from './ProductCommonUIs/InventoryUI';
import { AppContext } from '../../../Layout/Layout';

const InventoryByProduct = ({ ProductID, ProductCardState, setProductCardState, MainComponentFrom }) => {

  const { CartProductRelatedStates: { CartProductsList } } = useContext(AppContext)

  const fetchInventory = async () => {
    const ProductStock = await FetchProductStock({ ProductID });
    // Product Stock when have empty or error occured 
    if (ProductStock.Status === "OutOfStock") {
      setProductCardState({ type: "QtyDetails", payload: { ...ProductStock, ActStock: 0, CurrentStock: 0, UOM: "" } })
    }
    // Product Stock available from API Response 
    else if (ProductStock.Status === "InStock") {
      const FindSameProductStockReduce = CartProductsList.Data.filter(p => p.userProductsCartProductdetailsId === ProductID);
      const TotalCartStockValue = FindSameProductStockReduce.reduce((a, b) => a + b.CalculatedUOMQuantity, 0);
      const FinalProductStock = parseFloat(ProductStock.Data.CalculatedAvailableStock) - TotalCartStockValue;
      setProductCardState({
        type: "QtyDetails", payload: {
          ...ProductStock, ActStock: ProductStock.Data.CalculatedAvailableStock, CurrentStock: FinalProductStock > 0 ? FinalProductStock : 0,
          UOM: ProductStock.Data.AvailableStockUOM
        }
      })
    }

  }
  useEffect(() => {
    // Fetching Stock details of the Product When Price details not availabe or Error 
    if (ProductCardState.PriceDetails.Status !== "Loading") {
      if (ProductCardState.PriceDetails.Status !== "ErrorPrice") {
        fetchInventory();
      }
      else if (ProductCardState.PriceDetails.Status === "ErrorPrice") {
        setProductCardState({ type: "QtyDetails", payload: { Status: "StopLoading", ActStock: 9999, CurrentStock: 9999, UOM: "" } })
      }

    }
  }, [ProductCardState.PriceDetails])


  return (
    <>
      <InventoryUI QtyDetails={ProductCardState.QtyDetails} MainComponentFrom={MainComponentFrom} />
    </>
  )
}

export default InventoryByProduct